// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/metalldruck/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const metalldruckDE: PageEntry = {
  id: "post.metalldruck",
  locale: "de",
  slug: "metalldruck",
  seo: {
    title: "Glossar: Metalldruck einfach erklärt | Dietz GmbH",
    description: "Metalldruck bezieht sich auf einen Fertigungsprozess, bei dem Metall in eine bestimmte Form gedrückt oder gepresst wird, um komplexe Teile herzustellen. Im Kontext von Federn bezei",
  },
  type: "post",
  h1: "Glossar: Metalldruck einfach erklärt",
  intro: "Metalldruck bezieht sich auf einen Fertigungsprozess, bei dem Metall in eine bestimmte Form gedrückt oder gepresst wird, um komplexe Teile herzustellen. Im Kontext von Federn bezeichnet Metalldruck die Herstellung von Federn durch Umformen von Metallblechen oder Draht. Dieser Prozess ermöglicht die Produktion von Federn mit unterschiedlichen Formen und Geometrien. Metalldruck bietet Vorteile wie hohe Präzision, kostengünstige Massenproduktion und die Möglichkeit, komplexe Federdesigns zu realisieren. Der Metalldruck ist eine wichtige Technik in der Fertigung von Federn für verschiedene Anwendungen.",
  blocks: [

  ],
};
